export default __webpack_public_path__ + "static/media/008-bellboy.326953b5.svg";